export const quizCollectionPrivacy = {
  GLOBAL: 'Global',
  PRIVATE: 'Private',
  WORKSPACE: 'Workspace',
};

export const quizCollectionPrivacyList = [
  { label: 'Workspace Only', value: quizCollectionPrivacy.WORKSPACE },
  { label: 'Private', value: quizCollectionPrivacy.PRIVATE },
  { label: 'Global Mediphany', value: quizCollectionPrivacy.GLOBAL },
];

export default class QuizCollectionModel {
  static validateData(data) {
    if (!data) {
      return {
        errors: {},
        isValid: false,
      };
    }

    const errors = {};

    if (!data.title || data.title.trim().length === 0) {
      errors.title = 'Quiz collection title is required';
    }

    if (!data.description || data.description.trim().length === 0) {
      errors.description = 'Quiz collection description is required';
    }

    if (!data.privacy) {
      errors.privacy = 'Privacy setting is required';
    }

    if (data.privacy && !Object.values(quizCollectionPrivacy).includes(data.privacy)) {
      errors.privacy = 'Invalid privacy setting';
    }

    return {
      errors,
      isValid: Object.keys(errors).length === 0,
    };
  }

  static createEmpty() {
    return {
      description: '',
      id: null,
      materialQuizCollections: [],
      privacy: quizCollectionPrivacy.WORKSPACE,
      qualityObservationQuizCollections: [],
      tags: [],
      title: '',
    };
  }

  static fromApiResponse(apiData) {
    return {
      createdAt: apiData.createdAt,
      createdUserId: apiData.createdUserId,
      description: apiData.description,
      id: apiData.id,
      materialQuizCollections: apiData.materialQuizCollections || [],
      privacy: apiData.privacy,
      qualityObservationQuizCollections: apiData.qualityObservationQuizCollections || [],
      tags: apiData.tags || [],
      title: apiData.title,
      updatedAt: apiData.updatedAt,
      workspaceId: apiData.workspaceId,
    };
  }

  static toApiRequest(data) {
    return {
      description: data.description,
      materialIds: (data.materialQuizCollections || []).map((mqc) => mqc.materialId),
      privacy: data.privacy,
      qualityObservationIds: (data.qualityObservationQuizCollections || []).map((qoqc) => qoqc.qualityObservationId),
      tags: data.tags || [],
      title: data.title,
      workspaceId: data.workspaceId,
    };
  }
}
